import { NgModule, ModuleWithProviders } from '@angular/core'
import { CommonModule } from '@angular/common'
import { IcosTooltipModule } from '../tooltip/module'
import { IcosSliderButton } from './slider-button'
import { IcosSlider } from './slider'


@NgModule({
  declarations: [IcosSlider, IcosSliderButton],
  exports: [IcosSlider, IcosSliderButton],
  imports: [CommonModule, IcosTooltipModule],
  entryComponents: [IcosSlider],
})
export class IcosSliderModule {
  static forRoot(): ModuleWithProviders {
    return { ngModule: IcosSliderModule, providers: [] }
  }
}
